export const SET_VALIDATE_COUPON = 'SET_VALIDATE_COUPON'